module.exports = __webpack_public_path__ + "img/johnny_reve_americain.45894100.jpg";